<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                :heading="$t('modals.change_password.title')"
                :content="$t('modals.change_password.content')"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-page-header>
            <common-content-wrapper width="small">
                <change-password-form
                    @cancel="emitEvent({ name: 'close' })"
                    @success="emitEvent({ name: 'password-changed' })"
                ></change-password-form>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import ChangePasswordForm from 'components/forms/profile/ChangePasswordForm'

    export default {
        components: { ChangePasswordForm },

        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>
